import React from 'react'
import { AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons';
import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu';
import { SaleTaskTemplate } from '@sales/data/taskTemplates/TaskTemplateData';
import { useTaskTemplateDeleteAction } from '@sales/data/taskTemplates/TaskTemplateDataActions';
import TaskTemplateDialog from '../../dialogs/TaskTemplateDialog';

const TaskTemplateActionMenu = (props: { template: SaleTaskTemplate }) => {
    const deleteTemplateAction = useTaskTemplateDeleteAction();

    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Template">
                <TaskTemplateDialog.Button templateId={props.template.id} />
                <AgTechButton
                    text="Delete Template"
                    icon="fas fa-times"
                    action={async e => {
                        await e.actions.executeDataActionInModal(deleteTemplateAction, {
                            originalEntity: { template: props.template },
                            submittedEntity: { template: props.template }
                        });
                    }}
                />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
}

export default TaskTemplateActionMenu
